<template>
  <div class="con-wrap">
    <div class="set-state">
      <p class="set-title">设置说明</p>
      <div class="explain-box">
        <p>
          刷新间隔(分钟):设置每隔多少分钟刷新一次“告警提醒中心”。默认设置为1分钟。
        </p>
        <p>
          信息框停留时间（分钟）：设置“告警提醒中心”信息框每次刷新后在页面中停留的时间，达到停留时间后，信息框会自动关闭，待下一次刷新后重新显示。默认配置为1分钟。
        </p>
        <p>
          是否弹出显示：设置页面中是否显示“告警提醒中心”，设置成“是”显示，设置成“否”则不显示。默认设置为“是”。
        </p>
        <p>
          是否发声：
          设置有提醒信息时是否发声提醒，设置成“是”表示发声，设置成“否”则不发声。默认设置为“是”。
        </p>
      </div>
    </div>
    <div class="set-box">
      <el-form
        :rules="setRules"
        ref="setForm"
        :model="setForm"
        size="mini"
        label-width="190px"
        class="set-form-box"
      >
        <el-form-item
          class="set-form"
          prop="flushTime"
          label="刷新间隔（分钟）"
        >
          <el-input
            v-model.number="setForm.flushTime"
            placeholder="请输入"
          ></el-input>
          <span class="tips">提示：设置范围1-600分钟</span>
        </el-form-item>
        <el-form-item
          class="set-form"
          prop="stopTime"
          label="信息框停留时间（分钟）"
        >
          <el-input
            v-model.number="setForm.stopTime"
            placeholder="请输入"
          ></el-input>
          <span class="tips">提示：设置范围1-60分钟</span>
        </el-form-item>
        <el-form-item class="set-form" prop="newsDisplay" label="是否弹出显示">
          <el-select v-model="setForm.newsDisplay" placeholder="请选择">
            <el-option
              v-for="item in data"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="set-form"
          prop="dynamoVoice"
          label="发电告警是否发声"
        >
          <el-select v-model="setForm.dynamoVoice" placeholder="请选择">
            <el-option
              v-for="item in data"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="set-form"
          prop="vehicleVoice"
          label="车辆告警是否发声"
        >
          <el-select v-model="setForm.vehicleVoice" placeholder="请选择">
            <el-option
              v-for="item in data"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="set-form"
          prop="violationVoice"
          label="违规操作告警是否发声"
        >
          <el-select v-model="setForm.violationVoice" placeholder="请选择">
            <el-option
              v-for="item in data"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="set-form"
          prop="maintenanceVoice"
          label="维保告警是否发声"
        >
          <el-select v-model="setForm.maintenanceVoice" placeholder="请选择">
            <el-option
              v-for="item in data"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="set-form"
          prop="orderVoice"
          label="工单告警是否发声"
        >
          <el-select v-model="setForm.orderVoice" placeholder="请选择">
            <el-option
              v-for="item in data"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span class="btn-box">
        <el-button
          v-if="hasPerm('warn:remind:set')"
          type="primary"
          @click="saveOrUpdate"
          >保 存</el-button
        >
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      setForm: {
        flushTime: 1,
        stopTime: 1,
        newsDisplay: 1,
        dynamoVoice: 1,
        vehicleVoice: 1,
        violationVoice: 1,
        maintenanceVoice: 1,
        orderVoice: 1,
      },
      data: [
        { label: "是", value: 1 },
        { label: "否", value: 2 },
      ],
      setRules: {
        flushTime: [
          {
            required: true,
            trigger: "blur",
            message: "请输入刷新间隔时间",
          },
          { type: "number", trigger: "blur", message: "时间必须为数值" },
          {
            required: true,
            pattern: /^(?:[1-9]\d?|[1-5]\d{2}|600)$/,
            message: "请输入1-600的数值",
            trigger: "blur",
          },
        ],
        stopTime: [
          {
            required: true,
            trigger: "blur",
            message: "请输入信息框停留时间",
          },
          { type: "number", trigger: "blur", message: "时间必须为数值" },
          {
            required: true,
            pattern: /^(?:[1-9]|[1-5]\d?|60)$/,
            message: "请输入1-60的数值",
            trigger: "blur",
          },
        ],
        newsDisplay: [
          {
            required: true,
            trigger: "blur",
            message: "请选择是否弹出显示",
          },
        ],
        dynamoVoice: [
          {
            required: true,
            trigger: "blur",
            message: "请选择是否发声",
          },
        ],
        vehicleVoice: [
          {
            required: true,
            trigger: "blur",
            message: "请选择是否发声",
          },
        ],
        violationVoice: [
          {
            required: true,
            trigger: "blur",
            message: "请选择是否发声",
          },
        ],
        maintenanceVoice: [
          {
            required: true,
            trigger: "blur",
            message: "请选择是否发声",
          },
        ],
        orderVoice: [
          {
            required: true,
            trigger: "blur",
            message: "请选择是否发声",
          },
        ],
      },
    }
  },
  created() {
    this.getSetAlarm()
  },
  methods: {
    async getSetAlarm() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/warn/remind/set")
      if (res.code == 1) {
        _this.setForm = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    saveOrUpdate() {
      let _this = this
      _this.$refs.setForm.validate(async (valid) => {
        if (valid) {
          if (_this.setForm.stopTime > _this.setForm.flushTime) {
            _this.$message.warning("信息框停留时间不能大于刷新间隔")
            return
          }
          let { data: res } = await _this.$axios.patch(
            "/api/warn/remind/set",
            _this.setForm
          )
          if (res.code == 1) {
            _this.$message.success("设置成功，3s后自动刷新生效")
            //刷新页面设置生效
            setTimeout(() => {
              _this.$router.go(0)
            }, 3000)
          } else {
            _this.$message.warning(res.msg)
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  height: calc(100% - 40px);
  overflow: auto;
  font-size: 14px;
  color: #333;
}
.set-state {
  width: 100%;
  height: 200px;
  overflow: hidden;
  background-color: #fff;
  .set-title {
    height: 40px;
    line-height: 40px;
    padding-left: 16px;
    border-bottom: 1px solid #e0e0e0;
    font-weight: bold;
    font-size: 14px;
    color: #333;
  }
  .explain-box {
    padding: 10px 15px;
    p {
      line-height: 30px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
  }
}
.set-box /deep/ {
  width: 100%;
  margin-top: 20px;
  padding-top: 20px;
  height: calc(100% - 220px);
  background-color: #fff;
  box-sizing: border-box;
  .set-form-box {
    overflow: hidden;
  }
  .set-form {
    .el-select {
      width: 420px;
    }
    .el-input {
      width: 420px;
    }
    .el-form-item__label {
      line-height: 32px;
      float: left;
    }
    .el-form-item__content {
      margin-left: 4px !important;
      float: left;
    }
  }
  .tips {
    margin-left: 16px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }
  .btn-box {
    display: inline-block;
    width: 610px;
    margin-top: 20px;
    text-align: right;
  }
}
</style>
